const BaseComponent = require('common/home-block/extend');

class cpaListComp extends BaseComponent {
  init () {
    super.init();
    this.$listContainer = this.$el.find('.list-content');
    if (this.$listContainer.find('>li').length === 0) {
      this.$listContainer.append('<p class="noData">暂无数据</p>');
    }
  }
}
module.exports = cpaListComp;
